// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { otimDevnet as _otimDevnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the otimDevnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 41144114
 * Chain Name: Otim Devnet
 * Default Block Explorer: Not specified
 * Default RPC URL: http://devnet.otim.xyz
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { otimDevnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: otimDevnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const otimDevnet = createCommon({
	..._otimDevnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
